import {DI_TOKENS} from '@/di/di.tokens';
import {ModalType} from '@/stores/ModalStore/ModalStore.types';

import {injected} from 'brandi';

import {ResourcesAll} from '@/resources';
import {ModalStore} from '@/stores/ModalStore/ModalStore';

export class ModalControlSharedUseCase {
  constructor(
    private readonly modalStore: ModalStore,
    private readonly resources: ResourcesAll,
  ) {}

  public openModal: ModalStore['setCurrentModalType'] = (modalType) => {
    this.modalStore.setCurrentModalType(modalType);
  };

  public closeModal: ModalStore['resetCurrentModalType'] = () => {
    this.modalStore.resetCurrentModalType();
  };

  public handleOpenSettings = (isSettingsModalOpened: boolean): void => {
    if (isSettingsModalOpened) {
      this.closeModal();

      return;
    }
    this.openModal(ModalType.Settings);
  };

  public handleOpenBonuses = (isBonusesModalOpened: boolean): void => {
    if (this.resources.config.isProjectFinishedModalActive) {
      return;
    }

    if (isBonusesModalOpened) {
      this.closeModal();

      return;
    }
    this.openModal(ModalType.Bonuses);
  };

  public handleOpenItemDisabledModal = (): void => {
    this.openModal(ModalType.ItemDisabled);
  };

  public handleOpenItemCardModal = (): void => {
    this.openModal(ModalType.ItemCard);
  };

  public handleOpenItemLoadingModal = (): void => {
    this.openModal(ModalType.ItemLoading);
  };

  public handleOpenItemModal = (): void => {
    this.openModal(ModalType.ItemInfo);
  };

  public handleOpenUserEnergy = (): void => {
    this.openModal(ModalType.UserEnergy);
  };

  public handleOpenProjectFinished = (): void => {
    this.openModal(ModalType.ProjectFinished);
  };

  public handleOpenProjectFinishesSoon = (): void => {
    this.openModal(ModalType.ProjectFinishesSoon);
  };

  public handleOpenAllItemsOpened = (): void => {
    this.openModal(ModalType.AllItemsOpened);
  };
}

injected(ModalControlSharedUseCase, DI_TOKENS.modalStore, DI_TOKENS.resources);
